export enum PurchaseRequestStatus {
  INITIAL,
  CABINS_COMPLETED,
  PASSENGER_COMPLETED,
  PAYMENT_COMPLETED ,
  BOOCKING_CONFIRMATION_SENT
}
